export const SystemImages = {
	loginBackground: require('./images/login-background.png'),
	publicPlaceholder: require('./images/placeholder.png'),
	logoWithText: require('./images/logo.svg'),
	logo: require('./images/logo.png'),
	logoColourful: require('./images/logo-colourful.png'),
}
